/** @file The panel's status line numbers: images, images placed by a PSD import, slots. */
import type { Doc } from '@pose2d/format/types';

/** `placed` counts images with an `origin` (image.importLayers), which autoRig needs to build a skeleton. */
export function docCounts(doc: Doc): { images: number; placed: number; slots: number } {
  const images = Object.values(doc.images);
  return { images: images.length, placed: images.filter((i) => i.origin !== undefined).length, slots: Object.keys(doc.slots).length };
}
